/* Ready to order: buy her exact suit, in her size, with her request number.

   Shared by the Design Studio (after fit is submitted) and the private design-status page.
   Nuno, 2026-09-23: once fit is in, one clear purchase CTA, her size preselected, and her
   DesignRequest number on the order so Evelin can match it to her fit answers. Pay first,
   talk after.

   The backend decides everything that matters: `purchase` from status/ carries the
   product handle, the size value (computed server-side from her fit answers by the SAME
   function that creates the variant) and the request id. This file only finds that
   variant on the storefront, adds it to the cart with the request number as a line-item
   property, and goes to her cart (Nuno, 2026-09-24: not straight to checkout).

   States on the panel ([data-rto-state] on the root):
     loading      -- looking up her product
     ready        -- her size is on the product and available: Add to cart works
     pending      -- her size is not on the product yet (it is added right after fit);
                     checked again every few seconds for a couple of minutes
     unavailable  -- the product or her size cannot be bought online (sold, gone)
   A failed add-to-cart shows [data-rto-error] and leaves the button usable. */
(function () {
  'use strict';

  var POLL_MS = 5000;
  var POLL_TRIES = 24;

  function sameSize(a, b) {
    return String(a || '').trim().toUpperCase() === String(b || '').trim().toUpperCase();
  }

  function findVariant(product, size) {
    var variants = (product && product.variants) || [];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (sameSize(v.option1, size) || sameSize(v.title, size)) return v;
    }
    return null;
  }

  function money(cents) {
    var dollars = Number(cents) / 100;
    return '$' + (dollars % 1 ? dollars.toFixed(2) : String(dollars));
  }

  function lookup(handle, size) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' },
    }).then(function (r) {
      if (!r.ok) return { product: null, variant: null };
      return r.json().then(function (p) { return { product: p, variant: findVariant(p, size) }; });
    });
  }

  function addAndCheckout(variantId, requestId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{
        id: variantId, quantity: 1,
        /* Visible on purpose: it prints on the order Evelin works from, and on her
           cart as her own reference. */
        properties: { 'Design request': '#' + requestId },
      }] }),
    }).then(function (r) {
      if (!r.ok) throw new Error('cart ' + r.status);
      window.location.href = '/cart';
    });
  }

  function mount(root, purchase) {
    if (!root || !purchase || !purchase.handle || !purchase.size) return;
    var key = purchase.handle + '|' + purchase.size + '|' + purchase.request_id;
    if (root.getAttribute('data-rto-key') === key) return;   // already mounted for this
    root.setAttribute('data-rto-key', key);

    var sizeEl = root.querySelector('[data-rto-size]');
    var priceEl = root.querySelector('[data-rto-price]');
    var buy = root.querySelector('[data-rto-buy]');
    var errEl = root.querySelector('[data-rto-error]');
    var tries = 0;
    root.removeAttribute('data-rto-variant');
    root.setAttribute('data-rto-request', String(purchase.request_id));

    function setState(s) {
      root.setAttribute('data-rto-state', s);
      if (buy) { buy.disabled = s !== 'ready'; buy.hidden = s === 'unavailable'; }
      var msgs = root.querySelectorAll('[data-rto-msg]');
      for (var i = 0; i < msgs.length; i++) msgs[i].hidden = msgs[i].getAttribute('data-rto-msg') !== s;
      var promise = root.querySelector('[data-rto-promise]');
      if (promise) promise.hidden = s === 'unavailable';   // no order to promise about
    }
    if (sizeEl) sizeEl.textContent = purchase.size;
    if (priceEl && purchase.price) priceEl.textContent = '$' + purchase.price;
    root.hidden = false;
    setState('loading');

    function check() {
      if (root.getAttribute('data-rto-key') !== key) return;   // remounted for something else
      lookup(purchase.handle, purchase.size).then(function (found) {
        if (!found.product) { setState('unavailable'); return; }
        if (!found.variant) {
          if (++tries < POLL_TRIES) { setState('pending'); setTimeout(check, POLL_MS); }
          else setState('unavailable');
          return;
        }
        if (!found.variant.available) { setState('unavailable'); return; }
        root.setAttribute('data-rto-variant', String(found.variant.id));
        if (priceEl) priceEl.textContent = money(found.variant.price);
        setState('ready');
      }).catch(function () {
        if (++tries < POLL_TRIES) setTimeout(check, POLL_MS); else setState('unavailable');
      });
    }
    check();

    /* Bound once per panel; reads the CURRENT mount's variant and request off the root,
       so a remount (a changed size after an edit) can never buy the earlier one. */
    if (buy && !buy.getAttribute('data-rto-bound')) {
      buy.setAttribute('data-rto-bound', '1');
      buy.addEventListener('click', function () {
        var vid = root.getAttribute('data-rto-variant');
        if (!vid || root.getAttribute('data-rto-state') !== 'ready') return;
        if (errEl) errEl.hidden = true;
        buy.disabled = true;
        addAndCheckout(Number(vid), root.getAttribute('data-rto-request')).catch(function () {
          buy.disabled = false;
          if (errEl) errEl.hidden = false;
        });
      });
    }
  }

  window.IralsolPurchase = { mount: mount, findVariant: findVariant };
})();
